import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EnvironmentService } from '../../service/service.module';

@Injectable({ providedIn: 'root' })
export class ForecastLocationManagerService {
  environment = EnvironmentService.environment;

  public locationGridActionCellSubject: Subject<any> = new Subject();
  public locationSetupActionSubject: Subject<any> = new Subject();
  // Observables
  // setter
  setLocationGridActionCellSubject = (value: any) => { this.locationGridActionCellSubject.next(value); };
  setLocationSetupActionSubject = (value: any) => { this.locationSetupActionSubject.next(value); };
  // getter
  getLocationGridActionCellSubject = () => this.locationGridActionCellSubject.asObservable();
  getLocationSetupActionSubject = () => this.locationSetupActionSubject.asObservable();

  constructor(private http: HttpClient) {
  }
  
  ImportLocationManagerTemplate(body: any) {
    return this.http.post(`${this.environment.LocationManagerForecast}/importLocationManager`, body)
      .pipe(map(data => {
        return data;
      }));
  }
  LocationHierarchyGetList(body: any = {}) {
    return this.http.post(`${this.environment.LocationManagerForecast}/locationManagerGetList`, body)
      .pipe(map(response => {
        return response;
      }));
  }
  LocationManagerHierarchyGetList() {
    return this.http.get(`${this.environment.LocationManagerForecast}/locationManagerHierarchyGetList`)
      .pipe(map(response => {
        return response;
      }));
  }
  LocationManagerNodesGetList() {
    return this.http.get<any>(`${this.environment.LocationManagerForecast}/locationManagerNodesGetList`,)
      .pipe(map(response => {
        return response;
      }));
  }
  LocationManagerAdd(params: any) {
    return this.http.post(`${this.environment.LocationManagerForecast}/locationManagerAdd`, params)
      .pipe(map(response => {
        return response;
      }));
  }
  LocationManagerUpdate(params: any) {
    return this.http.post(`${this.environment.LocationManagerForecast}/locationManagerUpdate`, params)
      .pipe(map(response => {
        return response;
      }));
  }
  LocationManagerDelete(param: any) {
    return this.http.post(`${this.environment.LocationManagerForecast}/locationManagerDelete`, param)
      .pipe(map(response => {
        return response;
      }));
  }
  GetLocationSetupById(locationId: any) {
    return this.http.get(`${this.environment.LocationManagerForecast}/getLocationManagerById?locationId=${locationId}`)
      .pipe(map(response => {
        return response;
      }));
  }
}
